var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBosPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 13.2354H15V7.23535C15 6.97014 14.8946 6.71578 14.7071 6.52824C14.5196 6.34071 14.2652 6.23535 14 6.23535C13.7348 6.23535 13.4804 6.34071 13.2929 6.52824C13.1054 6.71578 13 6.97014 13 7.23535V13.2354H7C6.73478 13.2354 6.48043 13.3407 6.29289 13.5282C6.10536 13.7158 6 13.9701 6 14.2354C6 14.5006 6.10536 14.7549 6.29289 14.9425C6.48043 15.13 6.73478 15.2354 7 15.2354H13V21.2354C13 21.5006 13.1054 21.7549 13.2929 21.9425C13.4804 22.13 13.7348 22.2354 14 22.2354C14.2652 22.2354 14.5196 22.13 14.7071 21.9425C14.8946 21.7549 15 21.5006 15 21.2354V15.2354H21C21.2652 15.2354 21.5196 15.13 21.7071 14.9425C21.8946 14.7549 22 14.5006 22 14.2354C22 13.9701 21.8946 13.7158 21.7071 13.5282C21.5196 13.3407 21.2652 13.2354 21 13.2354Z",
    fill: "#19253D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.23535,
    width: 26,
    height: 26,
    rx: 13,
    stroke: "#19253D",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBosPlus);
export default __webpack_public_path__ + "static/media/bos_plus.38186171dd3a62def6326b1aadab1d07.svg";
export { ForwardRef as ReactComponent };